import { FromEventObservable } from './FromEventObservable';
export var fromEvent = FromEventObservable.create;
//# sourceMappingURL=fromEvent.js.map